import axios from "axios";
import React, { useEffect, useState } from "react";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { useNavigate, useParams } from "react-router-dom";
import sample from "../assets/sample.jpeg";
import heart from "../assets/heart.png";
import "../css/home.css";
import Loader from "../components/Loader";
import "../index.css";
import revealAnimation from "../components/Reveal";
import gsap from "gsap";
import { getUserName, setUserName } from "../utils/helpers";
import SpotlightCard from "../components/uikit/SpotlightCard";
import SplitText from "../components/uikit/SplitText";
import Squares from "../components/uikit/Squares";
import { useRef } from "react";
import VariableProximity from "../components/uikit/VariableProximity";
import StarBorder from "../components/uikit/StarBorder";
import LogoWall from "../components/uikit/LogoWall";
import lang from "../assets/heart.png";
import TiltedCard from "../components/uikit/TiltedCard";

import base from "../assets/QuickLabs.png";
import cs from "../assets/cs.jpeg";
import cn from "../assets/cn.jpeg";
import py from "../assets/py.jpeg";
import mern from "../assets/mern.jpeg";
import dm from "../assets/dm.jpeg";
import srs from "../assets/srs.jpeg";
import ml from "../assets/ml.jpeg";

import js from "../assets/js.png"
import op from "../assets/os.png"
import java from "../assets/java.png"
import ds from "../assets/ds.jpeg"
import react from "../assets/react.png"
import Magnet from "../components/uikit/Magnet";


const Home = () => {
  const { user } = useKindeAuth();
  const { username } = useParams();
  const [subjects, setSubjects] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [addSub, setAddsub] = useState(false);
  const [loading, setLoading] = useState(true);
  const [existingUser, setExistingUser] = useState(null);
  const [subjectName, setSubjectName] = useState("");
  const [subjectDescription, setSubjectDescription] = useState("");
  const [subjectImageURL, setSubjectImageURL] = useState("");
  const [cheatsheet, setCheatsheet] = useState("");
  const isAdmin = sessionStorage.getItem("isAdmin") === "true";
  const [formData, setFormData] = useState({
    username: "",
    name: `${user.given_name} ${user?.family_name}` || "",
    email: user.email,
    profileUrl: user.picture || "",
    role: "student",
    workplace: "",
  });
  const navigate = useNavigate();
  const containerRef = useRef(null);
  const logoImgs = [
    { imgUrl: lang, altText: "React Bits Logo" },
    { imgUrl: lang, altText: "React Bits Logo" },
    { imgUrl: lang, altText: "React Bits Logo" },
    { imgUrl: lang, altText: "React Bits Logo" },
    { imgUrl: lang, altText: "React Bits Logo" },
    { imgUrl: lang, altText: "React Bits Logo" },    
    { imgUrl: lang, altText: "React Bits Logo" },
    { imgUrl: lang, altText: "React Bits Logo" },
    { imgUrl: lang, altText: "React Bits Logo" },
    { imgUrl: lang, altText: "React Bits Logo" },
  ];
  const titlecardata = [
    { img: srs, altText: "srs", caption:"srs",overlayText:"srs",path:"/auth/srs" },
    { img: cs, altText: "cyber-security", caption:"cyber-security",overlayText:"cyber-security",path:"/auth/cyber-security" },
    { img: ml, altText: "machine-learning", caption:"machine-learning",overlayText:"machine-learning",path:"/auth/machine-learning" },
    { img: py, altText: "python", caption:"python",overlayText:"python",path:"/auth/python" },
    { img: cn, altText: "computer-networks", caption:"computer-networks",overlayText:"computer-networks",path:"/auth/computer-networks" },
    { img: dm, altText: "data-mining", caption:"data-mining",overlayText:"data-mining",path:"/auth/data-mining" },
  ];
  const base_url = process.env.REACT_APP_BASE_URL;

  const createLogForRegister = async (name) => {
    const timestamp = new Date().toLocaleString(); // Generate a timestamp
    const message = `:: Registered ::`; // Include timestamp in message
    const action = "Register";
    try {
      // Create a log first
      await axios.post(`${base_url}/log/add`, {
        username: name,
        message: message,
        action: action,
      });
      console.log("log added");
    } catch (error) {
      console.error("Error creating log:", error);
    }
  };

  const createLogForLogin = async (name) => {
    const timestamp = new Date().toLocaleString(); // Generate a timestamp
    const message = `:: Login ::`; // Include timestamp in message
    const action = "Login";
    try {
      // Create a log first
      await axios.post(`${base_url}/log/add`, {
        username: name,
        message: message,
        action: action,
      });
      console.log("log added");
    } catch (error) {
      console.error("Error creating log:", error);
    }
  };

  useEffect(() => {
    const checkEmail = async () => {
      try {
        const response = await fetch(`${base_url}/user`);
        if (!response.ok) {
          throw new Error("Failed to fetch users");
        }
        const data = await response.json();
        const userFound = data.find((u) => u.email === user.email);

        if (userFound) {
          createLogForLogin(userFound.username);
          setExistingUser(userFound);
          setUserName(userFound.username);
          const localusername = getUserName();
          sessionStorage.setItem("isAdmin", userFound.role === "admin");
          navigate(`/auth/home`);
        } else {
          setShowPopup(true);
        }
      } catch (error) {
        console.error("Error fetching users:", error);
        setLoading(false);
      } finally {
        setLoading(false);
      }
    };

    checkEmail();
    // fetchSubjects();
  }, [user.email, navigate]);

  // Trigger GSAP animation after subjects have been rendered
  useEffect(() => {
    if (subjects.length > 0) {
      // Apply GSAP animation to all subject cards
      gsap.fromTo(
        ".subject-card", // Target all elements with class "subject-card"
        { y: 100, opacity: 0 }, // Starting state (100px below and invisible)
        {
          y: 0,
          opacity: 1,
          duration: 1,
          ease: "power3.out",
          stagger: 0.1, // Each card starts 0.1 seconds after the previous one
        }
      );
    }
  }, [subjects]);

  revealAnimation(); // Assuming this is some additional animation

  const toggleSetAddSub = () => {
    setAddsub(!addSub);
  };

  const handleCardClick = (name) => {
    navigate(`/auth/${username}/${name}`);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFormSubmit = async () => {
    const { username, name, profileUrl, workplace } = formData;

    if (!username || !name || !profileUrl || !workplace) {
      alert("Please fill in all fields.");
      return;
    }

    try {
      const response = await fetch(`${base_url}/user/new`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const responseData = await response.json();

      if (response.ok) {
        setUserName(username);
        createLogForRegister(username);
        navigate(`/auth/home`);
      } else {
        if (responseData.message === "Username already exists") {
          alert("Username already exists. Please choose a different one.");
        } else if (responseData.message === "Email already exists") {
          alert("Email already exists. Please use a different email.");
        } else {
          alert("Failed to add user. Please try again later.");
        }
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Failed to add user. Please try again later.");
    }
  };

  const handleAnimationComplete = () => {
    console.log("All letters have animated!");
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <>
      <div className="sweethome">
        {/* <h1 className="reveal">Explore</h1> */}
        {/* <Loader/> */}
        <Squares
          speed={0.5}
          squareSize={40}
          direction="diagonal" // up, down, left, right, diagonal
          borderColor="#ffffff20"
          hoverFillColor="#333"
        />
        <div className="logowall1">
          <LogoWall
            items={logoImgs}
            direction="horizontal"
            pauseOnHover={true}
            size="clamp(8rem, 1rem + 20vmin, 25rem)"
            duration="60s"
            bgColor="#060606"
            bgAccentColor="#111111"
            position="left" // Show only the first marquee
          />
        </div>
        <Squares
          speed={0.5}
          squareSize={40}
          direction="diagonal" // up, down, left, right, diagonal
          borderColor="#ffffff20"
          hoverFillColor="#333"
        />
        {/* <div className="logowall2">
          <LogoWall
            items={logoImgs}
            direction="horizontal"
            pauseOnHover={true}
            size="clamp(8rem, 1rem + 20vmin, 25rem)"
            duration="60s"
            bgColor="#060606"
            bgAccentColor="#111111"
            position="right" // Show only the first marquee
          />
        </div> */}

        <SplitText
          text="explore"
          className="text-2xl font-semibold text-center SplitText-title"
          delay={150}
          animationFrom={{ opacity: 0, transform: "translate3d(0,50px,0)" }}
          animationTo={{ opacity: 1, transform: "translate3d(0,0,0)" }}
          easing="easeOutCubic"
          threshold={0.2}
          rootMargin="-50px"
          onLetterAnimationComplete={handleAnimationComplete}
        />
        <div ref={containerRef} className="varpoxy">
          <br />
          <div className="var-title">
            <VariableProximity
              label={"Need to submit your lab work? "}
              className={"variable-proximity-demo"}
              fromFontVariationSettings="'wght' 400, 'opsz' 9"
              toFontVariationSettings="'wght' 1000, 'opsz' 40"
              containerRef={containerRef}
              radius={100}
              falloff="linear"
            />
          </div>
          <br />
          <VariableProximity
            label={"Access step-by-step solutions for coding ,"}
            className={"variable-proximity-demo"}
            fromFontVariationSettings="'wght' 400, 'opsz' 9"
            toFontVariationSettings="'wght' 1000, 'opsz' 40"
            containerRef={containerRef}
            radius={100}
            falloff="linear"
          />
          <br />
          <VariableProximity
            label={"labs engineering labs, and more in"}
            className={"variable-proximity-demo"}
            fromFontVariationSettings="'wght' 400, 'opsz' 9"
            toFontVariationSettings="'wght' 1000, 'opsz' 40"
            containerRef={containerRef}
            radius={100}
            falloff="linear"
          />
          <br />
          <VariableProximity
            label={"every programming language."}
            className={"variable-proximity-demo"}
            fromFontVariationSettings="'wght' 400, 'opsz' 9"
            toFontVariationSettings="'wght' 1000, 'opsz' 40"
            containerRef={containerRef}
            radius={100}
            falloff="linear"
          />
          <br />
          <br />
          <Magnet padding={100} disabled={false} magnetStrength={10}>
          <button
            class="btn-23"
            onClick={() => {
              navigate("/auth/subjects");
            }}
            >
            <span class="text">Explore code solutions</span>
            <span aria-hidden="" class="marquee">
              codes
            </span>
          </button>
            </Magnet>
        </div>

        <div ref={containerRef} className="varpoxy1">
          <br />
          <div className="var-title">
            <VariableProximity
              label={"Stuck on a tough assignment?"}
              className={"variable-proximity-demo"}
              fromFontVariationSettings="'wght' 400, 'opsz' 9"
              toFontVariationSettings="'wght' 1000, 'opsz' 40"
              containerRef={containerRef}
              radius={100}
              falloff="linear"
            />
          </div>
          <br />
          <VariableProximity
            label={" We provide detailed solutions across all subjects"}
            className={"variable-proximity-demo"}
            fromFontVariationSettings="'wght' 400, 'opsz' 9"
            toFontVariationSettings="'wght' 1000, 'opsz' 40"
            containerRef={containerRef}
            radius={100}
            falloff="linear"
          />
          <br />
          <VariableProximity
            label={" and topics to help you finish fast"}
            className={"variable-proximity-demo"}
            fromFontVariationSettings="'wght' 400, 'opsz' 9"
            toFontVariationSettings="'wght' 1000, 'opsz' 40"
            containerRef={containerRef}
            radius={100}
            falloff="linear"
          />
          <br />
          <VariableProximity
            label={" and learn along the way."}
            className={"variable-proximity-demo"}
            fromFontVariationSettings="'wght' 400, 'opsz' 9"
            toFontVariationSettings="'wght' 1000, 'opsz' 40"
            containerRef={containerRef}
            radius={100}
            falloff="linear"
          />
          <br />
        </div>
        <div className="retro-cards">
        {titlecardata.map((card, index) => (
        <TiltedCard
          key={index}
          imageSrc={card.img}
          altText={card.altText}
          captionText={card.caption}
          containerHeight="250px"
          containerWidth="250px"
          imageHeight="250px"
          imageWidth="250px"
          rotateAmplitude={12}
          scaleOnHover={1.2}
          showMobileWarning={false}
          showTooltip={true}
          displayOverlayContent={true}
          overlayContent={
            <p className="tilted-card-demo-text">{card.overlayText}</p>
          }
          path={card.path}
        />
      ))}
        </div>
      </div>
      {showPopup && (
        <div className="popup">
          <div className="popup-content">
            <h2>Welcome!</h2>
            <p>Your email is not registered. Please complete your profile.</p>
            <div>
              <label>
                Username:
                <input
                  type="text"
                  name="username"
                  value={formData.username}
                  onChange={handleInputChange}
                />
              </label>
            </div>
            <div>
              <label>
                Name:
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                />
              </label>
            </div>
            <div>
              <label>
                Workplace:
                <input
                  type="text"
                  name="workplace"
                  value={formData.workplace}
                  onChange={handleInputChange}
                />
              </label>
            </div>
            <button onClick={handleFormSubmit}>Complete Profile</button>
          </div>
        </div>
      )}
    </>
  );
};

export default Home;
